import { useSmallScreen } from '@/hooks/useWindowDimension';
import { HelpPopover } from '@/components/HelpPopover/HelpPopover';
import { HELP_ARTICLES } from '@/helpers/helpArticles';
import legendClasses from '@/views/map/MapLayerManager/MapLayerLegend.module.css';
import classes from './HeatmapLegend.module.css';

export const HeatmapLegend = () => {
  const isSmallScreen = useSmallScreen();
  return (
    <div data-testid="heatmap-legend">
      {!isSmallScreen && (
        <div className={legendClasses.legendTitle}>
          Fall-in & health heat map
          <HelpPopover
            link={HELP_ARTICLES.fallInHealth}
            linkText="Fall-in & health"
            fontSize="sm"
          />
        </div>
      )}
      <div className={`${legendClasses.legend} ${classes.layout}`}>
        <span className={classes.gradient} />
        <span style={{ textAlign: 'left' }}>
          Low density of
          <br />
          risk trees
        </span>
        <span style={{ textAlign: 'right' }}>
          High density of
          <br />
          risk trees
        </span>
      </div>
    </div>
  );
};
